import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";

import PageLayout from "./components/PageLayout";
import SignInPage from "./pages/SignInPage";

function App(props) {
  const user = useSelector((state) => state.auth.user);
  // const loading = useSelector((state) => state.common.loading);

  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  // user.is_admin = 1
  return (
    <BrowserRouter>
      {user && accessToken && refreshToken ? <PageLayout /> : <SignInPage />}
    </BrowserRouter>
  );
}

export default App;
